import { render, staticRenderFns } from "./CompanyLeaveRight.vue?vue&type=template&id=ec2d952c&scoped=true"
import script from "./CompanyLeaveRight.vue?vue&type=script&lang=js"
export * from "./CompanyLeaveRight.vue?vue&type=script&lang=js"
import style0 from "./CompanyLeaveRight.vue?vue&type=style&index=0&id=ec2d952c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2d952c",
  null
  
)

export default component.exports